export const SETTINGS_MODAL_SURFACE_STYLE_TEXT = `
/* Modal (match Companies style, but scoped). */
.kg-settings-modal-backdrop {
  position: fixed;
  inset: 0;
  background: var(--kg-settings-overlay-scrim, color-mix(in srgb, var(--ds-text, currentColor) 70%, transparent));
  display: flex;
  align-items: center;
  justify-content: center;
  padding: var(--ui-space-18, 18px);
  z-index: 99999;
}
.kg-settings-modal-backdrop.hidden { display: none; }
.kg-settings-modal-frame-host {
  width: min(880px, 90vw);
  max-height: min(76vh, 760px);
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}
.kg-settings-modal-frame-host > .ds-modal {
  width: min(880px, 90vw) !important;
  max-width: 100%;
  max-height: min(76vh, 760px);
  overflow: hidden;
}
.kg-settings-modal-frame-host > .ds-modal > .ds-modal__body {
  width: 100%;
  display: flex;
  flex-direction: column;
  min-height: 0;
}
.kg-settings-modal-frame-host[data-modal-kind="access-edit"] {
  width: min(1040px, 86vw);
  max-height: min(78vh, 720px);
}
.kg-settings-modal-frame-host[data-modal-kind="access-edit"] > .ds-modal {
  width: min(1040px, 86vw) !important;
  max-height: min(78vh, 720px);
}
.kg-settings-modal-frame-host[data-modal-kind="json"] {
  width: min(960px, 92vw);
}
.kg-settings-modal-frame-host[data-modal-kind="json"] > .ds-modal {
  width: min(960px, 92vw) !important;
}
.kg-settings-modal-backdrop .modal-card {
  width: min(1120px, 98vw);
  max-height: 88vh;
  overflow: auto;
  background: var(--kg-settings-overlay-surface, var(--ds-surface-raised, Canvas));
  border: 1px solid var(--kg-settings-overlay-border, var(--ds-border-subtle, currentColor));
  border-radius: var(--ui-radius-16, 16px);
  padding: var(--ui-space-14, 14px);
}
.kg-settings-modal-backdrop .modal-title { font-size: var(--ui-font-size-15, 15px); font-weight: 600; letter-spacing: 0.03em; margin-bottom: 6px; }
.kg-settings-modal-backdrop .modal-message { font-size: var(--ui-font-size-13, 13px); color: var(--kg-settings-overlay-text-2, var(--ds-text-subtle, var(--ds-text-muted, GrayText))); margin-bottom: 14px; }
.kg-settings-modal-backdrop .modal-actions { display: flex; gap: 10px; justify-content: flex-end; margin-top: 14px; }
.kg-settings-modal-backdrop .kg-settings-structured-shell {
  display: flex;
  flex-direction: column;
  gap: 12px;
  min-height: 0;
  height: 100%;
}
.kg-settings-modal-backdrop .kg-settings-structured-scroll {
  flex: 1 1 auto;
  min-height: 0;
  max-height: min(52vh, 560px);
  overflow: auto;
  border: 1px solid var(--kg-settings-overlay-structured-border, color-mix(in srgb, var(--kg-settings-overlay-border, currentColor) 100%, transparent));
  border-radius: var(--ui-radius-12, 12px);
  background: var(--kg-settings-overlay-structured-surface, color-mix(in srgb, var(--kg-settings-overlay-border, currentColor) 8%, transparent));
  padding: var(--ui-space-10, 10px);
}
.kg-settings-modal-backdrop .kg-settings-structured {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.kg-settings-modal-backdrop .kg-settings-structured-empty {
  color: color-mix(in srgb, var(--kg-settings-overlay-text, var(--ds-text, currentColor)) 60%, transparent);
}
.kg-settings-modal-backdrop .kg-settings-structured-note {
  color: color-mix(in srgb, var(--kg-settings-overlay-text, var(--ds-text, currentColor)) 65%, transparent);
  font-size: 12px;
}
.kg-settings-modal-backdrop .kg-settings-structured-pill {
  display: inline-flex;
  align-items: center;
  max-width: 100%;
  padding: 4px 8px;
  border-radius: 999px;
  background: color-mix(in srgb, var(--kg-settings-overlay-text, var(--ds-text, currentColor)) 8%, transparent);
  color: color-mix(in srgb, var(--kg-settings-overlay-text, var(--ds-text, currentColor)) 90%, transparent);
  font-size: 12px;
  line-height: 1.3;
  word-break: break-word;
}
.kg-settings-modal-backdrop .kg-settings-structured-row {
  display: grid;
  grid-template-columns: minmax(140px, 220px) minmax(0, 1fr);
  gap: 12px;
  align-items: start;
  padding: 8px 0;
  border-bottom: 1px solid color-mix(in srgb, var(--kg-settings-overlay-border, currentColor) 78%, transparent);
}
.kg-settings-modal-backdrop .kg-settings-structured-row:last-child {
  border-bottom: none;
}
.kg-settings-modal-backdrop .kg-settings-structured-key {
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: color-mix(in srgb, var(--kg-settings-overlay-text, var(--ds-text, currentColor)) 62%, transparent);
}
.kg-settings-modal-backdrop .kg-settings-structured-value {
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.kg-settings-modal-backdrop .kg-settings-structured-table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
}
.kg-settings-modal-backdrop .kg-settings-structured-table th,
.kg-settings-modal-backdrop .kg-settings-structured-table td {
  padding: 8px 10px;
  border-bottom: 1px solid color-mix(in srgb, var(--kg-settings-overlay-border, currentColor) 78%, transparent);
  text-align: left;
  vertical-align: top;
  word-break: break-word;
}
.kg-settings-modal-backdrop .kg-settings-structured-table th {
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: color-mix(in srgb, var(--kg-settings-overlay-text, var(--ds-text, currentColor)) 62%, transparent);
}
.kg-settings-modal-backdrop .kg-settings-structured-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.kg-settings-modal-backdrop .kg-settings-structured-details {
  margin: 0;
  border: 1px solid color-mix(in srgb, var(--kg-settings-overlay-border, currentColor) 78%, transparent);
  border-radius: var(--ui-radius-10, 10px);
  background: color-mix(in srgb, var(--kg-settings-overlay-surface, var(--ds-surface-raised, Canvas)) 55%, transparent);
  padding: 8px 10px;
}
.kg-settings-modal-backdrop .kg-settings-structured-summary {
  cursor: pointer;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: color-mix(in srgb, var(--kg-settings-overlay-text, var(--ds-text, currentColor)) 68%, transparent);
}
.kg-settings-modal-backdrop .kg-settings-structured-block {
  margin-top: 8px;
  padding-left: 6px;
  border-left: 2px solid color-mix(in srgb, var(--kg-settings-overlay-border, currentColor) 100%, transparent);
}
`;
